import { COLORS } from '@cocolocala/ui-components';
import { styled } from 'linaria/react';
import React, { CSSProperties, FC, ReactNode } from 'react';
type Props = {
  style?: CSSProperties;
  children: ReactNode;
};
const InputErrorMessage: FC<Props> = ({
  style,
  children
}) => {
  return <ErrorMessage style={style}>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className="icon">
        <path fillRule="evenodd" clipRule="evenodd" d="M7.13356 3.5C7.51846 2.83333 8.48071 2.83333 8.86561 3.5L13.8002 12.047C14.1851 12.7137 13.704 13.547 12.9342 13.547H3.06497C2.29517 13.547 1.81404 12.7137 2.19894 12.047L7.13356 3.5ZM7.33249 6H8.66582V10H7.33249V6ZM8.66582 10.6667H7.33249V12H8.66582V10.6667Z" fill="#FF4D4F" />
      </svg>
      <ErrorMessageText>{children}</ErrorMessageText>
    </ErrorMessage>;
};
export default InputErrorMessage;
const ErrorMessage = /*#__PURE__*/styled("div")({
  name: "ErrorMessage",
  class: "e1cpftii"
});
const ErrorMessageText = /*#__PURE__*/styled("p")({
  name: "ErrorMessageText",
  class: "ed0jqpd"
});

require("./index.linaria.module.css!=!../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./index.tsx");